/* Vimeo Player */

$(function () {
	$(document).ready(function () {
		var options = {
			width: 640,
			height: 360,
			responsive: true,
			loop: true
		};

		var players = $('.vimeo-player');

		players.each(function () {
			var containerElement = this;
			var vimeoPlayer = new Vimeo.Player(containerElement, options);

			$(".js-vimeo-play").on('click', function (e) {
				e.preventDefault();
				$(this).closest(".video").addClass("is-playing");
				vimeoPlayer.play();
			});

			vimeoPlayer.on('pause', function (data) {
				containerElement.closest('.video').removeClass("is-playing");
			});
		});
	});
});